export default "__VITE_ASSET__C5fWMuY$__"